import { globalSettingsBlocFactory } from './chunk-AC2U4AAA.mjs';
import { firestore } from './chunk-CBPAVK33.mjs';

// src/global-settings.ts
var globalSettingsBloc = globalSettingsBlocFactory(firestore);

export { globalSettingsBloc };
//# sourceMappingURL=global-settings.mjs.map
//# sourceMappingURL=global-settings.mjs.map